/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

// Forest datasets
import * as Blockly from "blockly/core";
import "blockly/python";
import { AreaService } from "@/services/area.service";
import { getAllowedStatements } from "../block_compatibility_checks";
import { areaChange } from '../helper_functions';

/*
 * Block definition for forest change data selection
 */
Blockly.Blocks['input_forest_data'] = {
    init: function() {
        var area_dropdown = AreaService.getAreas();
        this.appendDummyInput("first_input")
            .appendField("Other Forest Change Datasets: ")
            .appendField(
                new Blockly.FieldDropdown([
                    ["PALSAR forest change ", "PALSAR"],
                    ["Carbomap Scotland Forest Loss", "carbomap"],
                    ["Above ground biomass", "biomass"],
                ]),
                "dropdown"
            )
            
        this.appendDummyInput("second_input")
            .appendField("Parameter: ", "param_text")
            .appendField(
            new Blockly.FieldDropdown([
                ["Forest cover", "_fnf"],
                ["Loss", "_loss"],
                ["Gain", "_gain"],
                ["Loss and Gain", "_loss_gain"],
                ["Loss/Extent/Gain", "_all"],
            ]),
            "param"
        );
        this.appendDummyInput("inp")
            .appendField("Area: ", "area_text")
            .appendField(new Blockly.FieldDropdown(area_dropdown), "area");
        this.appendStatementInput("do").setCheck(
            getAllowedStatements("forest_data")
        );
        
        this.getInput("inp")
            .appendField("  From: ", "from_text")
            .appendField(
                new Blockly.FieldDropdown(
                    [
                        ["2007", "2007"],
                        ["2008", "2008"],
                        ["2009", "2009"],
                        ["2010", "2010"],
                        ["2015", "2015"],
                        ["2016", "2016"],
                        ["2017", "2017"],
                    ]
                ),
                "fd_yearly"
            )
            .appendField("  To: ", "to_text")
            .appendField(
                new Blockly.FieldDropdown(
                    [
                        ["2007", "2007"],
                        ["2008", "2008"],
                        ["2009", "2009"],
                        ["2010", "2010"],
                        ["2015", "2015"],
                        ["2016", "2016"],
                        ["2017", "2017"],
                    ]
                ),
                "td_yearly"
            );

        let dropd = this.getField("td_yearly");
        dropd.setValue("2008");
        this.setInputsInline(false);
        this.setStyle("forest");
        this.setTooltip(Blockly.Msg.FOREST_DATA_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        this.previous_data = "PALSAR";
        this.previous_area = "Area 1";

        this.setOnChange(() => {

            if (this.previous_data !== this.getFieldValue("dropdown")) {
                this.updateShape_();
                this.previous_data = this.getFieldValue("dropdown");
            }
            if (this.getFieldValue("area") !== this.previous_area) {
                if (this.getFieldValue("area") == "upload_shp") {
                    this.updateAreaParams_("add");
                } else if (this.previous_area == "upload_shp") {
                    this.updateAreaParams_("remove");
                }
                this.previous_area = this.getFieldValue("area");
            }
        });

        this.areaSubscription = AreaService.areaChange$.subscribe( () => {
            let result = areaChange(this, "inp", "area");
            if(!result) {
                this.areaSubscription.unsubscribe();
            }
        });
    },

    updateShape_: function() {
        var choice = this.getFieldValue("dropdown");
        try {
            this.getInput("second_input").removeField("param");
        } catch (e) {
            /**/
        }

        try {
            this.getInput("inp").removeField("from_text");
            this.getInput("inp").removeField("fd_yearly");
            this.getInput("inp").removeField("to_text");
            this.getInput("inp").removeField("td_yearly");
        } catch (e) {
            /**/
        }

        if (choice == "carbomap") {
            this.getInput("second_input").appendField(
                new Blockly.FieldDropdown([["Loss", "_loss"]]),
                "param"
            );
        } else if (choice == "PALSAR") {
            this.getInput("second_input").appendField(
                new Blockly.FieldDropdown([
                    ["Forest cover", "_fnf"],
                    ["Loss", "_loss"],
                    ["Gain", "_gain"],
                    ["Loss and Gain", "_loss_gain"],
                    ["Loss/Extent/Gain", "_all"],
                ]),
                "param"
            );
            this.getInput("inp")
                .appendField("  From: ", "from_text")
                .appendField(
                    new Blockly.FieldDropdown(
                        [
                            ["2007", "2007"],
                            ["2008", "2008"],
                            ["2009", "2009"],
                            ["2010", "2010"],
                            ["2015", "2015"],
                            ["2016", "2016"],
                            ["2017", "2017"],
                        ]
                    ),
                    "fd_yearly"
                )
                .appendField("  To: ", "to_text")
                .appendField(
                    new Blockly.FieldDropdown(
                        [
                            ["2007", "2007"],
                            ["2008", "2008"],
                            ["2009", "2009"],
                            ["2010", "2010"],
                            ["2015", "2015"],
                            ["2016", "2016"],
                            ["2017", "2017"],
                        ]
                    ),
                    "td_yearly"
                );
            let dropd = this.getField("td_yearly");
            dropd.setValue("2008");
        } else if (choice == "biomass") {
            this.getInput("second_input").appendField(
                new Blockly.FieldDropdown([["Biomass", "_bio"]]),
                "param"
            );
            this.getInput("inp")
                .appendField("  From: ", "from_text")
                .appendField(
                    new Blockly.FieldDropdown(
                        [
                            ["2007", "2007"],
                            ["2008", "2008"],
                            ["2009", "2009"],
                            ["2010", "2010"],
                            ["2015", "2015"],
                            ["2016", "2016"],
                            ["2017", "2017"],
                        ]
                    ),
                    "fd_yearly"
                )
                .appendField("  To: ", "to_text")
                .appendField(
                    new Blockly.FieldDropdown(
                        [
                            ["2007", "2007"],
                            ["2008", "2008"],
                            ["2009", "2009"],
                            ["2010", "2010"],
                            ["2015", "2015"],
                            ["2016", "2016"],
                            ["2017", "2017"],
                        ]
                    ),
                    "td_yearly"
                );
            let dropd = this.getField("td_yearly");
            dropd.setValue("2008");
        }
    },

    updateAreaParams_: function(param) {
        if (param == "add") {
            this.getInput("area_input")
                .appendField(" Path: ", "path_text")
                .appendField(
                    new Blockly.FieldTextInput("user/shp_name"),
                    "path"
                );
        } else {
            try {
                this.getInput("area_input").removeField("path_text");
                this.getInput("area_input").removeField("path");
            } catch (e) {
                console.log("Input does not exist");
            }
        }
    },
};